/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EntityUser } from '../../models/entity-user';

export interface ApiKeycloakGetUserGet$Json$Params {
  username?: string;
  Authorization?: string;
}

export function apiKeycloakGetUserGet$Json(http: HttpClient, rootUrl: string, params?: ApiKeycloakGetUserGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EntityUser>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakGetUserGet$Json.PATH, 'get');
  if (params) {
    rb.query('username', params.username, {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EntityUser>;
    })
  );
}

apiKeycloakGetUserGet$Json.PATH = '/api/keycloak/GetUser';
